import React from 'react';
import PropTypes from 'prop-types';

// components
import { FormattedMessage } from 'react-intl';
import BuyerAssuranceIcon from 'dibs-vg/dist/react/buyer-assurance';

// styles
import styles from './Benefits.scss';

function Benefit({ children }) {
    return (
        <div className={styles.benefit}>
            <BuyerAssuranceIcon className={styles.icon} />
            <p className={styles.text}>{children}</p>
        </div>
    );
}

Benefit.propTypes = {
    children: PropTypes.node.isRequired,
};

export const benefitVetted = (
    <Benefit>
        <FormattedMessage
            id="PdpRespBuyerAssuranceBox.vetted"
            defaultMessage="Only Vetted, Professional Sellers"
        />
    </Benefit>
);

export const benefitProtection = (
    <Benefit>
        <FormattedMessage
            id="PdpRespBuyerAssuranceBox.protection"
            defaultMessage="Buyer Protection Guaranteed"
        />
    </Benefit>
);
export const benefitDelivery = (
    <Benefit>
        <FormattedMessage
            id="PdpRespBuyerAssuranceBox.delivery"
            defaultMessage="Fully Insured Global Deliveries"
        />
    </Benefit>
);
